import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"

type Tenant = {
  name: string | null
  includeVat: boolean | null
  hasBeepaidGoModule: boolean
}

export const retrieveSelfTenant =
  async (): Promise<Tenant> => {
    const { body } = await api.get<Tenant>(
      "/beepaidgo/current-tenant/"
    )
    return body
  }

export const CURRENT_TENANT_QUERY_KEY = "current_tenant"
export const useCurrentTenant = () => {
  const { data, ...queryReturn } = useQuery({
    queryKey: [CURRENT_TENANT_QUERY_KEY],
    queryFn: () => retrieveSelfTenant(),
    retry: false,
  })

  return {
    currentTenant: data,
    ...queryReturn,
  }
}
